import React from 'react';
/**
 * Hook to generate an aria-describedby field based on field properties from Formik
 * as well as a description field. Relies on the error and description IDs generated
 * in <GenericFormElement />.
 */
export default function useAriaDescribedByField(_ref) {
  let {
    meta,
    description,
    ...rest
  } = _ref;
  const name = 'name' in rest ? rest.name : rest.field.name;
  const ariaDescribedBy = React.useMemo(() => {
    const ids = [];
    if (description) {
      ids.push("".concat(name, "-description"));
    }
    if (meta.touched && meta.error) {
      ids.push("".concat(name, "-error"));
    }
    return ids.join(' ');
  }, [meta.touched, meta.error, description, name]);
  return {
    ariaDescribedBy
  };
}